
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Scatter/index.md?watch=parent';
    export const demoIndex = {
  ids: ["scatter-demo-common","scatter-demo-markdown","scatter-demo-group"],
  getter: () => import(/* webpackChunkName: "meta__Scatter" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Scatter/index.md?type=demo')
};